/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable card for the IPSAT 2.0 Archetype Report dashboard.
 * Per Steve's 2026-05-11 spec — title + descriptor + "Learn more" CTA
 * that opens an archetype-specific modal.
 */
@Component({
  selector: 'app-archetype-dashboard-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dashboard-card.component.html',
  styleUrls: ['./dashboard-card.component.scss'],
})
export class ArchetypeDashboardCardComponent {
  @Input() title!: string;
  @Input() description!: string;
  @Input() ctaText: string = 'Learn more';

  @Output() learnMore = new EventEmitter<void>();

  onLearnMore(): void {
    this.learnMore.emit();
  }
}
